import lozad from "lozad";
import moment from "moment";

$(function () {

    var observer = lozad();
    observer.observe();

    moment.locale("sv");

    var $body = $("body");
    WidgetHandler.InitWidgets($body);

    $(".sidenav-toggler").click(function () {
        $("#sidenav").css("width", "100%");
    });
    $("#sidenav .sidenav-closer").click(function () {
        $("#sidenav").css("width", "0");
    });

    $("#modalVideo").on("hide.bs.modal", function (event) {
        $("#modalVideo")
            .find("iframe")
            .attr("src", "");
    });
});

$(document).ready(function () {
    $('.responsive-slider').slick({
        autoplay: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

function initMap() {
    $("html").addClass("mapavailable");
    $(document).trigger("mapAvailable");
}
